var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.5 11.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.75 -6.305)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.966,6A.924.924,0,0,0,12,6.867v9.262a.927.927,0,0,0,.966.871h3.088a.25.25,0,1,0,0-.5H12.966a.406.406,0,0,1-.44-.371V6.867a.4.4,0,0,1,.44-.367h3.088a.25.25,0,1,0,0-.5Zm6.369,3.059a.261.261,0,0,0-.22.169.242.242,0,0,0,.068.261l1.9,1.762H15.08a.256.256,0,0,0-.251.262.259.259,0,0,0,.275.238h5.983l-1.9,1.758a.241.241,0,0,0,0,.354.273.273,0,0,0,.372,0l2.368-2.188a.241.241,0,0,0,0-.355L19.553,9.133A.271.271,0,0,0,19.336,9.058Z",
    transform: "translate(-12 -5.445)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ca362dcd.svg";
export { ForwardRef as ReactComponent };